<template>
  <section id="Regler" class="section">
    <div class="section-header js-section-header">
      <h2>Regler</h2>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="card">
            <div class="card-body">
              <h2 class="card-title">Reglerne</h2>
              <ul>
                <li>
                  Det er påbudt at bære løbsnummeret synligt efter løbsledelsens
                  anvisninger.
                </li>
                <li>
                  Holdet må ikke modtage hjælp udefra - hverken i form af udstyr
                  eller fødevarer/drikkevarer under løbet.
                </li>
                <li>
                  Deltagerne skal være selvforsynende under hele løbet. Der vil
                  dog være mulighed for at tanke vand ved skiltede steder.
                </li>
                <li>
                  Den enkelte deltager skal kunne svømme 20 meter uden hjælp.
                </li>
                <li>
                  Bemærk at det ikke er tilladt for den ene af deltagerne at
                  fortsætte løbet på egen hånd, hvis den anden må udgå.
                </li>
                <li>
                  Hvis et hold vælger at udgå, søger man den korteste vej mod
                  mål, og melder ved ankomst straks til tilstedeværende
                  løbsofficial.
                </li>
                <li>
                  Man skal hjælpe andre hold, hvis et uheld eller nogen som
                  helst form for fare skulle opstå. Overtrædelse af denne regel
                  vil medføre diskvalifikation.
                </li>
              </ul>
              <strong
                >Det skal pointeres at deltagelse i løbet sker på eget ansvar,
                og løbsledelsen kan ikke drages til ansvar for evt. skader på
                deltagere og materiel.</strong
              >
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="card">
            <div class="card-body">
              <h2 class="card-title">Diskvalifikation</h2>
              <ul>
                <li>
                  De 2 deltagere er længere end <strong>10 meter</strong> fra
                  hinanden.
                </li>
                <li>Holdet ikke følger ruten.</li>
                <li>Holdet efterlader affald eller andet.</li>
                <li>Holdet ikke hjælper andre hold i nød.</li>
              </ul>
              <h2 class="card-title">Arrangøren har ret til at:</h2>
              <ul>
                <li>Diskvalificere hold.</li>
                <li>Ændre ruten.</li>
                <li>
                  Aflyse eller udsætte konkurrencen, eksempelvis pga.
                  vejrforhold.
                </li>
                <li>
                  Afgøre protester efter at have overvejet alle muligheder.
                </li>
              </ul>
              <strong
                >Arrangøren kan ikke holdes ansvarlig for tyveri, bortkomst,
                beskadigelse el. lign. af deltagernes udstyr. Noter venligst at
                du deltager på egen risiko, og at du er ansvarlig for din egen
                sikkerhed.</strong
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "rules"
};
</script>

<style lang="scss" scoped>
.section {
  background-image: linear-gradient(#c5ebcb, #b2e5ba);
}
</style>
